import { FormBuilder, FormGroup, Validators } from "@angular/forms";

export interface AgentGroup {
    id: number,
    group_name: string;
    strategy: any
    wrap_up_time: any
    mask: any
    didgroupid: any
    auto_answer:any
    auto_script:any
    email: any
    calendar: any
    disposition_id:any
    announcement_key: any
    queue_audio_key: any

}

export interface HTTPAgentgroup {
    id: number,
    group_name: string;
    strategy: any
    wrap_up_time: any
    mask: any
    didgroupid: any
    auto_answer: any
    auto_script:any
    email: any
    calendar: any
    disposition_id:any
    announcement_key: any
    queue_audio_key: any

}

export class AgentgroupForm implements HTTPAgentgroup {
    public id: number;
    public group_name: string;
    public strategy: any
    public wrap_up_time: any
    public mask: any
    public didgroupid: any
    public auto_answer: any;
    public auto_script:any
    public email: any
    public calendar: any
    public disposition_id:any
    public announcement_key: any
    public queue_audio_key: any


    // public supervisiorType:any

    constructor(data: AgentGroup) {
        console.log("data", data)
        if (data == null) {
            this.id = 0;
            this.group_name = "";
            this.strategy = "";
            this.wrap_up_time = "30";
            this.mask = 1;
            this.didgroupid = "-1";
            this.auto_answer= 0;
            this.auto_script =""
            this.email = "-1";
            this.calendar = "-1";
            this.disposition_id = "-1"
            this.announcement_key = "-1";
            this.queue_audio_key = "-1";
        }
        else {
            this.id = data.id;
            this.group_name = data.group_name;
            this.strategy = data.strategy;
            this.wrap_up_time = data.wrap_up_time;
            this.mask = data.mask
            this.didgroupid = data.didgroupid != 0 ? data.didgroupid : "-1";
            this.auto_answer = data.auto_answer;
            this.auto_script = data.auto_script;
            this.email = data.email != 0 ? data.email : "-1";
            this.calendar = data.calendar == null ? "-1" : data.calendar
            this.disposition_id = data.disposition_id == null ? "-1" : data.disposition_id
            this.announcement_key = data.announcement_key == null || data.announcement_key == 0 ? "-1" : data.announcement_key
            this.queue_audio_key = data.queue_audio_key == null || data.queue_audio_key == 0 ? "-1" : data.queue_audio_key
        }
    }

    public makeform(fb: FormBuilder): FormGroup {
        return fb.group({
            // id: [this.id],
            group_name: [this.group_name, Validators.required],
            strategy: [this.strategy, Validators.required],
            wrap_up_time: [this.wrap_up_time, [Validators.required, Validators.pattern("^[0-9]*$"), Validators.minLength(1), Validators.maxLength(4), Validators.min(5), Validators.max(3600)]],
            mask: [this.mask],
            didgroupid: [this.didgroupid],
            auto_answer: [this.auto_answer],
            auto_script: [this.auto_script],
            email: [this.email],
            calendar: [this.calendar],
            disposition_id: [this.disposition_id],
            announcement_key: [this.announcement_key],
            queue_audio_key: [this.queue_audio_key]
        });
    }

    public saveForm(fg: FormGroup): boolean {
        if (fg.valid) {
            this.group_name = fg.get("group_name").value;
            this.strategy = fg.get("strategy").value;
            this.wrap_up_time = fg.get("wrap_up_time").value;
            this.mask = fg.get("mask").value;
            this.didgroupid = fg.get("didgroupid").value;
            this.auto_answer = fg.get("auto_answer").value;
            this.auto_script = fg.get("auto_script").value;
            this.email = fg.get("email").value,
            this.calendar = fg.get("calendar").value
            this.disposition_id = fg.get("disposition_id").value
            this.announcement_key = fg.get("announcement_key").value
            this.queue_audio_key = fg.get("queue_audio_key").value

            return true;
        }
        else {
            return false;
        }
    }

}

export interface Agent {

    id: number,
    username: string;
    fullname: string,
    name: string,
    password: number,
    email: string,
    agentgroupid: number;
    skill: any;
    smtp_id: any;
    supervisor: number;
    mask: any
    calendar: any
    id_did: any;
    wrap_up_time: any;
    callback_login:any;
    skills?: any;
    languages?: any;
}

export interface HTTPAgent {
    id: number,
    username: string;
    fullname: string,
    // name: string,
    password: number,
    // email: string,
    agentgroupid: number;
    skill: any;
    smtp_id: any;
    supervisor: number;
    calendar: any;
    id_did: any;
    wrap_up_time: any;
    callback_login: any;
    skills: any;
    languages: any;
}

export class AgentForm implements HTTPAgent {
    public id: number;
    public username: string;
    public fullname: string;
    // public name: string;
    public password: number;
    // public email: string;
    public agentgroupid: number;
    public skill: any;
    public smtp_id: any;
    public supervisor: number;
    public group_name: string;
    public mask: any
    public calendar: any
    public id_did: any
    public wrap_up_time: any
    public callback_login: any;
    public skills: any[];
    public languages: any[];

    constructor(data: Agent) {
        if (data == null) {
            // this.id = 0;
            this.username = '';
            this.fullname = "";
            this.group_name = "";
            this.password = null;
            // this.email = null;
            this.agentgroupid = 0;
            this.skill = "";
            this.supervisor = 0
            this.smtp_id = 0;
            this.mask = 1
            this.calendar = 0;
            this.id_did = "";
            this.wrap_up_time = '0';
            this.callback_login = 1;
            this.skills = [];
            this.languages = [];

        }
        else {

            if (data.id_did != null && data.id_did != 'null' && data.id_did != undefined && data.id_did != 'undefined') {
                const unescapedString = data.id_did.replace(/\\(.)/g, "$1")
                var DIDid = JSON.parse(unescapedString);
                console.log("getting data into object :::", DIDid);
            } else {
                DIDid = [];
            }
            this.id = data.id;
            this.username = data.username;
            this.fullname = data.fullname;
            // this.name = data.name;
            this.password = data.password;
            // this.email = data.email;
            // this.agentgroupid = data.agentgroupid;
            this.skill = data.skill;
            this.smtp_id =JSON.parse(data.smtp_id);
            this.supervisor = data.supervisor;
            this.mask = data.mask
            this.calendar = JSON.parse(data.calendar);
            this.id_did = DIDid;
            this.wrap_up_time = data.wrap_up_time;
            this.callback_login = data.callback_login == 1 ? data.callback_login : 0
            this.skills = this.parseJsonArray(data.skills);
            this.languages = this.parseJsonArray(data.languages);


        }
    }

    private parseJsonArray(val: any): any[] {
        if (!val || val === 'null' || val === 'undefined') {
            return [];
        }
        if (Array.isArray(val)) {
            return val;
        }
        try {
            const str = typeof val === 'string' ? val.replace(/\\(.)/g, "$1") : val;
            const parsed = JSON.parse(str);
            return Array.isArray(parsed) ? parsed : [];
        } catch {
            return [];
        }
    }

    public makeform(fb: FormBuilder): FormGroup {
        return fb.group({
            // id: [this.id],
            username: [this.username, Validators.required],
            fullname: [this.fullname, Validators.required],
            // name: [this.name, Validators.required],
            password: [this.password, Validators.required],
            // email: [this.email, [Validators.required, Validators.email]],
            // agentgroupid: [this.agentgroupid],
            // group_name: [this.group_name],
            // agentid: [this.agentid],
            skill: [this.skill, [Validators.required]],
            supervisor:[this.supervisor],
            smtp_id:[this.smtp_id],
            mask:[this.mask],
            calendar:[this.calendar],
            id_did:[this.id_did],
            wrap_up_time: [this.wrap_up_time, [Validators.required, Validators.pattern("^[0-9]*$"), Validators.minLength(1), Validators.maxLength(4), Validators.min(5), Validators.max(3600)]],
            callback_login: [this.callback_login],
            skills: [this.skills],
            languages: [this.languages],

           
        //    ,supervisiorType:[this.supervisiorType]
        });
    }

    public saveForm(fg: FormGroup): boolean {
        if (fg.valid) {
            this.username = fg.get("username").value;
            this.fullname = fg.get("fullname").value;
            this.password = fg.get("password").value;
            // this.email = fg.get("email").value;
            // this.agentgroupid = fg.get("agentgroupid").value;
            this.skill = fg.get("skill").value;
            // this.supervisor=fg.get("supervisor").value;
            this.smtp_id = fg.get("smtp_id").value;
            this.mask = fg.get("mask").value;
            this.calendar = fg.get("calendar").value;
            this.id_did = fg.get("id_did").value;
            // this.supervisiorType=fg.get("supervisiorType").value
            this.wrap_up_time = fg.get("wrap_up_time").value;
            this.callback_login = fg.get("callback_login").value;
            this.skills = fg.get("skills").value || [];
            this.languages = fg.get("languages").value || [];
            return true;
        }
        else {
            return false;
        }
    }

}